import { router } from '@inertiajs/react'
import type { AdminPagination } from '@/types'

// Fleet-canonical pagination controls. Wire shape (snake_case):
// { page, per_page, total, total_pages }. Preserves existing query params.
export default function AdminPaginationBar({ pagination, baseUrl, params = {} }: {
  pagination: AdminPagination
  baseUrl: string
  params?: Record<string, string | undefined>
}) {
  const { page, per_page, total, total_pages } = pagination
  if (!total_pages || total_pages <= 1) return null

  const go = (toPage: number) => {
    const query: Record<string, string> = { page: String(toPage) }
    for (const [k, v] of Object.entries(params)) if (v) query[k] = v
    router.get(baseUrl, query, { preserveState: true, preserveScroll: true })
  }

  const from = (page - 1) * per_page + 1
  const to = Math.min(page * per_page, total)

  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-base-content/60">{from}–{to} of {total}</span>
      <div className="join">
        <button className="btn btn-sm join-item" disabled={page <= 1} onClick={() => go(page - 1)}>
          « Prev
        </button>
        <button className="btn btn-sm join-item" disabled={page >= total_pages} onClick={() => go(page + 1)}>
          Next »
        </button>
      </div>
    </div>
  )
}
